
import YesOrNo from "./YesOrNo";

export default YesOrNo;